var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.616 5.239a1.313 1.313 0 00-1.857-1.857L24 22.142 5.24 3.382A1.313 1.313 0 003.385 5.24l18.76 18.759-18.76 18.76a1.313 1.313 0 001.857 1.856L24 25.854l18.76 18.76a1.313 1.313 0 001.856-1.857l-18.76-18.759 18.76-18.76z"}));
}

Close.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Close;

Close.default = Close;
